export const visit = (vm, at) => {
at({ "de": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Neue Nachricht" } } });
};